import smavaIllustration from 'assets/icons/voucher-money-smava-full.png'
import ffgIllustration from 'assets/icons/voucher-money-ffg-full.png'
import { VoucherBannerVariant } from '../../VoucherBanner.types'

export const VARIANT_COPY: Record<
  VoucherBannerVariant,
  {
    illustration: string
    body: (amount: number | null) => string
  }
> = {
  smava: {
    illustration: smavaIllustration,
    body: (amount) => {
      return `aktivieren, Kreditvertrag über smava.de abschließen & ${amount ? `${amount} €` : ''} Gutschein per E-Mail erhalten`
    }
  },
  ffg: {
    illustration: ffgIllustration,
    body: (amount) => {
      return `aktivieren, Kreditvertrag über finanzcheck.de abschließen & ${amount ? `${amount} €` : ''} Gutschein per E-Mail erhalten`
    }
  }
}
